import React from 'react';
import moment from 'moment';
import {makeStyles} from '@material-ui/core';
import {CSVLink} from "react-csv";
import customAxios from "../../API/customAxios";
import {headers, data} from './csvHeader'
import IconButton from '@material-ui/core/IconButton';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import Tooltip from '@material-ui/core/Tooltip';

const useStyles = makeStyles((theme) => ({
    csvLink: {
        color: 'white',
        '&:hover': {
            color: 'white',
        },
        display: 'contents'
    },
    iconButton: {
        height: 36,
    },
    icon: {
        color: '#FFF',
    }
}));

export default function Export({setIsActive}) {
    const classes = useStyles();
    const [csvEmployeeRecord, setCsvEmployeeRecord] = React.useState([]);
    const [filename, setFilename] = React.useState('');
    const [getHeaders, setHeaders] = React.useState([]);
    const csvLink = React.useRef();

    function getData() {
        setIsActive(true);
        customAxios.get(`/get_employee_allowances?is_export=true`)
            .then(res => {
                const csvData = res.data['results'];
                const currentDate = moment().format('YYYY_MM_DD');
                setHeaders(headers(res.data['active_year']));
                setFilename('Employee_Records_' + currentDate + '.csv');
                const record = [];
                for (let i = 0; i < csvData.length; i++) {
                    record.push(data(csvData[i]));
                }
                setCsvEmployeeRecord(record);
                setIsActive(false);
                csvLink.current.link.click();
            })
    }

    return (
        <>
            <Tooltip title={'Download CSV'}>
                <IconButton onClick={getData} className={classes.iconButton}>
                    <CloudDownloadIcon className={classes.icon}/>
                </IconButton>
            </Tooltip>
            <CSVLink filename={filename} data={csvEmployeeRecord} headers={getHeaders}
                     className={classes.csvLink}
                     ref={csvLink}/>

        </>
    );
}
